/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { BYOCWrapper, FEaaSWrapper } from '@sitecore-jss/sitecore-jss-nextjs';

import * as CdpPageView from 'src/components/CdpPageView';
import * as ColumnSplitter from 'src/components/ColumnSplitter';
import * as Container from 'src/components/Container';
import * as FEAASScripts from 'src/components/FEAASScripts';
import * as FallbackServerError from 'src/components/FallbackServerError';
import * as Image from 'src/components/Image';
import * as LinkList from 'src/components/LinkList';
import * as Navigation from 'src/components/Navigation';
import * as PageContent from 'src/components/PageContent';
import * as PartialDesignDynamicPlaceholder from 'src/components/PartialDesignDynamicPlaceholder';
import * as Promo from 'src/components/Promo';
import * as RichText from 'src/components/RichText';
import * as RowSplitter from 'src/components/RowSplitter';
import * as Title from 'src/components/Title';
import * as BackToTop from 'src/components/BackToTop/BackToTop';
import * as BackToTopTailwind from 'src/components/BackToTop/BackToTopTailwind';
import * as ProductInformation from 'src/components/ProductInformation/ProductInformation';
import * as ProductInformationTailwind from 'src/components/ProductInformation/ProductInformationTailwind';
import * as WriteAReview from 'src/components/WriteAReview/WriteAReview';
import * as WriteAReviewTailwind from 'src/components/WriteAReview/WriteAReviewTailwind';
import * as Accordion from 'src/components/authorable/Accordion/Accordion';
import * as AccordionTailwind from 'src/components/authorable/Accordion/AccordionTailwind';
import * as ArticleCallout from 'src/components/authorable/ArticleCallout/ArticleCallout';
import * as ArticleCalloutTailwind from 'src/components/authorable/ArticleCallout/ArticleCalloutTailwind';
import * as ArticleCard from 'src/components/authorable/ArticleCard/ArticleCard';
import * as ArticleCardTailwind from 'src/components/authorable/ArticleCard/ArticleCardTailwind';
import * as ArticleRelatedProducts from 'src/components/authorable/ArticleRelatedProducts/ArticleRelatedProducts';
import * as ArticleRelatedProductsTailwind from 'src/components/authorable/ArticleRelatedProducts/ArticleRelatedProductsTailwind';
import * as ArticleResultsListwithSearchgraphql from 'src/components/authorable/ArticleResultsListwithSearch/ArticleResultsListwithSearch.graphql';
import * as ArticleResultsListwithSearch from 'src/components/authorable/ArticleResultsListwithSearch/ArticleResultsListwithSearch';
import * as ArticleResultsListwithSearchtypes from 'src/components/authorable/ArticleResultsListwithSearch/ArticleResultsListwithSearch.types';
import * as ArticleVideo from 'src/components/authorable/ArticleVideo/ArticleVideo';
import * as ArticleVideoTailwind from 'src/components/authorable/ArticleVideo/ArticleVideoTailwind';
import * as BazaarVoiceSocial from 'src/components/authorable/BazaarVoiceSocial/BazaarVoiceSocial';
import * as BrandCard from 'src/components/authorable/BrandCard/BrandCard';
import * as BrandCardTailwind from 'src/components/authorable/BrandCard/BrandCardTailwind';
import * as Breadcrumbgraphql from 'src/components/authorable/Breadcrumb/Breadcrumb.graphql';
import * as Breadcrumb from 'src/components/authorable/Breadcrumb/Breadcrumb';
import * as Breadcrumbtypes from 'src/components/authorable/Breadcrumb/Breadcrumb.types';
import * as BreadcrumbTailwind from 'src/components/authorable/Breadcrumb/BreadcrumbTailwind';
import * as Carousel from 'src/components/authorable/Carousel/Carousel';
import * as CarouselTailwind from 'src/components/authorable/Carousel/CarouselTailwind';
import * as MediaGalleryCarousel from 'src/components/authorable/Carousel/MediaGalleryCarousel';
import * as MediaGalleryCarouselTailwind from 'src/components/authorable/Carousel/MediaGalleryCarouselTailwind';
import * as ProductCarousel from 'src/components/authorable/Carousel/ProductCarousel';
import * as ProductCarouselTailwind from 'src/components/authorable/Carousel/ProductCarouselTailwind';
import * as CategoryCard from 'src/components/authorable/CategoryCard/CategoryCard';
import * as categorycardsbg from 'src/components/authorable/CategoryCard/category.cards.bg';
import * as Grid from 'src/components/authorable/CategoryCard/Components/Grid';
import * as SideBySide from 'src/components/authorable/CategoryCard/Components/SideBySide';
import * as ContactUsPromo from 'src/components/authorable/ContactUsPromo/ContactUsPromo';
import * as ContactUsPromoTailwind from 'src/components/authorable/ContactUsPromo/ContactUsPromoTailwind';
import * as ContentBlock from 'src/components/authorable/ContentBlock/ContentBlock';
import * as ContentList from 'src/components/authorable/ContentList/ContentList';
import * as ContentListTailwind from 'src/components/authorable/ContentList/ContentListTailwind';
import * as DartPromo from 'src/components/authorable/DartPromo/DartPromo';
import * as DartPromoTailwind from 'src/components/authorable/DartPromo/DartPromoTailwind';
import * as FeaturedJobCard from 'src/components/authorable/FeaturedJobCard/FeaturedJobCard';
import * as FeaturedJobCardTailwind from 'src/components/authorable/FeaturedJobCard/FeaturedJobCardTailwind';
import * as Flockler from 'src/components/authorable/Flockler/Flockler';
import * as FlocklerTailwind from 'src/components/authorable/Flockler/FlocklerTailwind';
import * as Footergraphql from 'src/components/authorable/Footer/Footer.graphql';
import * as Footer from 'src/components/authorable/Footer/Footer';
import * as FooterTailwind from 'src/components/authorable/Footer/FooterTailwind';
import * as FormContainer from 'src/components/authorable/FormContainer/FormContainer';
import * as FragranceResultsListwithSearch from 'src/components/authorable/FragranceResultsListwithSearch/FragranceResultsListwithSearch';
import * as GenericCard from 'src/components/authorable/GenericCard/GenericCard';
import * as GenericCardTailwind from 'src/components/authorable/GenericCard/GenericCardTailwind';
import * as GlossaryTab from 'src/components/authorable/GlossaryTab/GlossaryTab';
import * as GlossaryTabTailwind from 'src/components/authorable/GlossaryTab/GlossaryTabTailwind';
import * as Ingredientgraphql from 'src/components/authorable/GlossaryTab/Ingredient.graphql';
import * as Headergraphql from 'src/components/authorable/Header/Header.graphql';
import * as Header from 'src/components/authorable/Header/Header';
import * as HeaderDesktop from 'src/components/authorable/Header/HeaderDesktop';
import * as HeaderDesktopTailwind from 'src/components/authorable/Header/HeaderDesktopTailwind';
import * as HeaderMobile from 'src/components/authorable/Header/HeaderMobile';
import * as HeaderMobileTailwind from 'src/components/authorable/Header/HeaderMobileTailwind';
import * as Headline from 'src/components/authorable/Headline/Headline';
import * as HeadlineTailwind from 'src/components/authorable/Headline/HeadlineTailwind';
import * as HeroArticle from 'src/components/authorable/HeroArticle/HeroArticle';
import * as HeroArticleTailwind from 'src/components/authorable/HeroArticle/HeroArticleTailwind';
import * as HomepageHero from 'src/components/authorable/HeroHomepage/HomepageHero';
import * as HeroInternal from 'src/components/authorable/HeroInternal/HeroInternal';
import * as HeroInternalTailwind from 'src/components/authorable/HeroInternal/HeroInternalTailwind';
import * as HeroSDS from 'src/components/authorable/HeroSDS/HeroSDS';
import * as HeroSDSTailwind from 'src/components/authorable/HeroSDS/HeroSDSTailwind';
import * as IconCard from 'src/components/authorable/IconCard/IconCard';
import * as IconCardTailwind from 'src/components/authorable/IconCard/IconCardTailwind';
import * as Jebbit from 'src/components/authorable/Jebbit/Jebbit';
import * as JumpLinks from 'src/components/authorable/JumpLinks/JumpLinks';
import * as JumpLinksTailwind from 'src/components/authorable/JumpLinks/JumpLinksTailwind';
import * as DartContainer from 'src/components/authorable/Layout/DartContainer/DartContainer';
import * as DartLayout from 'src/components/authorable/Layout/DartLayout/DartLayout';
import * as MediaGallery from 'src/components/authorable/MediaGallery/MediaGallery';
import * as MediaGalleryTailwind from 'src/components/authorable/MediaGallery/MediaGalleryTailwind';
import * as MediaVideo from 'src/components/authorable/MediaVideo/MediaVideo';
import * as MediaVideoTailwind from 'src/components/authorable/MediaVideo/MediaVideoTailwind';
import * as MosquitoForecastNewsletter from 'src/components/authorable/MosquitoForcast/MosquitoForecastNewsletter';
import * as MosquitoForecastNewsletterPopup from 'src/components/authorable/MosquitoForcast/MosquitoForecastNewsletterPopup';
import * as MosquitoForecastPromo from 'src/components/authorable/MosquitoForcast/MosquitoForecastPromo';
import * as MosquitoForecastResult from 'src/components/authorable/MosquitoForcast/MosquitoForecastResult';
import * as MosquitoForecastThankYou from 'src/components/authorable/MosquitoForcast/MosquitoForecastThankYou';
import * as PDFResultsListwithSearchgraphql from 'src/components/authorable/PDFResultsListwithSearch/PDFResultsListwithSearch.graphql';
import * as PDFResultsListwithSearch from 'src/components/authorable/PDFResultsListwithSearch/PDFResultsListwithSearch';
import * as PDFResultsListwithSearchtypes from 'src/components/authorable/PDFResultsListwithSearch/PDFResultsListwithSearch.types';
import * as ProductCard from 'src/components/authorable/ProductCard/ProductCard';
import * as ProductSingleCard from 'src/components/authorable/ProductCard/Component/ProductSingleCard';
import * as ProductResultsListwithSearch from 'src/components/authorable/ProductResultsListwithSearch/ProductResultsListwithSearch';
import * as PullQuote from 'src/components/authorable/PullQuote/PullQuote';
import * as PullQuoteItem from 'src/components/authorable/PullQuote/PullQuoteItem';
import * as Quiz from 'src/components/authorable/Quiz/Quiz';
import * as RTE from 'src/components/authorable/RTE/RTE';
import * as RelatedArticleCardListingwithSearch from 'src/components/authorable/RelatedArticleCardListingwithSearch/RelatedArticleCardListingwithSearch';
import * as SDSResultsListwithSearchgraphql from 'src/components/authorable/SDSResultsListwithSearch/SDSResultsListwithSearch.graphql';
import * as SDSResultsListwithSearch from 'src/components/authorable/SDSResultsListwithSearch/SDSResultsListwithSearch';
import * as SDSResultsListwithSearchtypes from 'src/components/authorable/SDSResultsListwithSearch/SDSResultsListwithSearch.types';
import * as SearchHero from 'src/components/authorable/SearchHero/SearchHero';
import * as SearchHeroTailwind from 'src/components/authorable/SearchHero/SearchHeroTailwind';
import * as SearchResult from 'src/components/authorable/SearchResult/SearchResult';
import * as Spacer from 'src/components/authorable/Spacer/Spacer';
import * as Stats from 'src/components/authorable/Stats/Stats';
import * as StatsTailwind from 'src/components/authorable/Stats/StatsTailwind';
import * as TopBar from 'src/components/authorable/TopBar/TopBar';
import * as TopBarTailwind from 'src/components/authorable/TopBar/TopBarTailwind';
import * as WhereToBuygraphql from 'src/components/authorable/WhereToBuy/WhereToBuy.graphql';
import * as WhereToBuy from 'src/components/authorable/WhereToBuy/WhereToBuy';
import * as startItemQuerygraphql from 'src/components/authorable/WhereToBuy/startItemQuery.graphql';
import * as GraphQLIntegratedDemo from 'src/components/reference/graphql/GraphQL-IntegratedDemo';
import * as GraphQLLayout from 'src/components/reference/graphql/GraphQL-Layout';

export const components = new Map();
components.set('BYOCWrapper', BYOCWrapper);
components.set('FEaaSWrapper', FEaaSWrapper);

components.set('CdpPageView', CdpPageView);
components.set('ColumnSplitter', ColumnSplitter);
components.set('Container', Container);
components.set('FEAASScripts', FEAASScripts);
components.set('FallbackServerError', FallbackServerError);
components.set('Image', Image);
components.set('LinkList', LinkList);
components.set('Navigation', Navigation);
components.set('PageContent', PageContent);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('Promo', Promo);
components.set('RichText', RichText);
components.set('RowSplitter', RowSplitter);
components.set('Title', Title);
components.set('BackToTop', BackToTop);
components.set('BackToTopTailwind', BackToTopTailwind);
components.set('ProductInformation', ProductInformation);
components.set('ProductInformationTailwind', ProductInformationTailwind);
components.set('WriteAReview', WriteAReview);
components.set('WriteAReviewTailwind', WriteAReviewTailwind);
components.set('Accordion', Accordion);
components.set('AccordionTailwind', AccordionTailwind);
components.set('ArticleCallout', ArticleCallout);
components.set('ArticleCalloutTailwind', ArticleCalloutTailwind);
components.set('ArticleCard', ArticleCard);
components.set('ArticleCardTailwind', ArticleCardTailwind);
components.set('ArticleRelatedProducts', ArticleRelatedProducts);
components.set('ArticleRelatedProductsTailwind', ArticleRelatedProductsTailwind);
components.set('ArticleResultsListwithSearch.graphql', ArticleResultsListwithSearchgraphql);
components.set('ArticleResultsListwithSearch', ArticleResultsListwithSearch);
components.set('ArticleResultsListwithSearch.types', ArticleResultsListwithSearchtypes);
components.set('ArticleVideo', ArticleVideo);
components.set('ArticleVideoTailwind', ArticleVideoTailwind);
components.set('BazaarVoiceSocial', BazaarVoiceSocial);
components.set('BrandCard', BrandCard);
components.set('BrandCardTailwind', BrandCardTailwind);
components.set('Breadcrumb.graphql', Breadcrumbgraphql);
components.set('Breadcrumb', Breadcrumb);
components.set('Breadcrumb.types', Breadcrumbtypes);
components.set('BreadcrumbTailwind', BreadcrumbTailwind);
components.set('Carousel', Carousel);
components.set('CarouselTailwind', CarouselTailwind);
components.set('MediaGalleryCarousel', MediaGalleryCarousel);
components.set('MediaGalleryCarouselTailwind', MediaGalleryCarouselTailwind);
components.set('ProductCarousel', ProductCarousel);
components.set('ProductCarouselTailwind', ProductCarouselTailwind);
components.set('CategoryCard', CategoryCard);
components.set('category.cards.bg', categorycardsbg);
components.set('Grid', Grid);
components.set('SideBySide', SideBySide);
components.set('ContactUsPromo', ContactUsPromo);
components.set('ContactUsPromoTailwind', ContactUsPromoTailwind);
components.set('ContentBlock', ContentBlock);
components.set('ContentList', ContentList);
components.set('ContentListTailwind', ContentListTailwind);
components.set('DartPromo', DartPromo);
components.set('DartPromoTailwind', DartPromoTailwind);
components.set('FeaturedJobCard', FeaturedJobCard);
components.set('FeaturedJobCardTailwind', FeaturedJobCardTailwind);
components.set('Flockler', Flockler);
components.set('FlocklerTailwind', FlocklerTailwind);
components.set('Footer.graphql', Footergraphql);
components.set('Footer', Footer);
components.set('FooterTailwind', FooterTailwind);
components.set('FormContainer', FormContainer);
components.set('FragranceResultsListwithSearch', FragranceResultsListwithSearch);
components.set('GenericCard', GenericCard);
components.set('GenericCardTailwind', GenericCardTailwind);
components.set('GlossaryTab', GlossaryTab);
components.set('GlossaryTabTailwind', GlossaryTabTailwind);
components.set('Ingredient.graphql', Ingredientgraphql);
components.set('Header.graphql', Headergraphql);
components.set('Header', Header);
components.set('HeaderDesktop', HeaderDesktop);
components.set('HeaderDesktopTailwind', HeaderDesktopTailwind);
components.set('HeaderMobile', HeaderMobile);
components.set('HeaderMobileTailwind', HeaderMobileTailwind);
components.set('Headline', Headline);
components.set('HeadlineTailwind', HeadlineTailwind);
components.set('HeroArticle', HeroArticle);
components.set('HeroArticleTailwind', HeroArticleTailwind);
components.set('HomepageHero', HomepageHero);
components.set('HeroInternal', HeroInternal);
components.set('HeroInternalTailwind', HeroInternalTailwind);
components.set('HeroSDS', HeroSDS);
components.set('HeroSDSTailwind', HeroSDSTailwind);
components.set('IconCard', IconCard);
components.set('IconCardTailwind', IconCardTailwind);
components.set('Jebbit', Jebbit);
components.set('JumpLinks', JumpLinks);
components.set('JumpLinksTailwind', JumpLinksTailwind);
components.set('DartContainer', DartContainer);
components.set('DartLayout', DartLayout);
components.set('MediaGallery', MediaGallery);
components.set('MediaGalleryTailwind', MediaGalleryTailwind);
components.set('MediaVideo', MediaVideo);
components.set('MediaVideoTailwind', MediaVideoTailwind);
components.set('MosquitoForecastNewsletter', MosquitoForecastNewsletter);
components.set('MosquitoForecastNewsletterPopup', MosquitoForecastNewsletterPopup);
components.set('MosquitoForecastPromo', MosquitoForecastPromo);
components.set('MosquitoForecastResult', MosquitoForecastResult);
components.set('MosquitoForecastThankYou', MosquitoForecastThankYou);
components.set('PDFResultsListwithSearch.graphql', PDFResultsListwithSearchgraphql);
components.set('PDFResultsListwithSearch', PDFResultsListwithSearch);
components.set('PDFResultsListwithSearch.types', PDFResultsListwithSearchtypes);
components.set('ProductCard', ProductCard);
components.set('ProductSingleCard', ProductSingleCard);
components.set('ProductResultsListwithSearch', ProductResultsListwithSearch);
components.set('PullQuote', PullQuote);
components.set('PullQuoteItem', PullQuoteItem);
components.set('Quiz', Quiz);
components.set('RTE', RTE);
components.set('RelatedArticleCardListingwithSearch', RelatedArticleCardListingwithSearch);
components.set('SDSResultsListwithSearch.graphql', SDSResultsListwithSearchgraphql);
components.set('SDSResultsListwithSearch', SDSResultsListwithSearch);
components.set('SDSResultsListwithSearch.types', SDSResultsListwithSearchtypes);
components.set('SearchHero', SearchHero);
components.set('SearchHeroTailwind', SearchHeroTailwind);
components.set('SearchResult', SearchResult);
components.set('Spacer', Spacer);
components.set('Stats', Stats);
components.set('StatsTailwind', StatsTailwind);
components.set('TopBar', TopBar);
components.set('TopBarTailwind', TopBarTailwind);
components.set('WhereToBuy.graphql', WhereToBuygraphql);
components.set('WhereToBuy', WhereToBuy);
components.set('startItemQuery.graphql', startItemQuerygraphql);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
